
let initialState = {
	isDeleteModalVisible: false,
	worksheet: [],
	offset:0,
	loader1:false,
	templateFormModal:false,
	crisisSplit:null,
	selectFilter:null,
	selectSplit:null,
	selectBrandFilter:null
};
const Worksheets = (state = initialState, action) => {
	switch (action.type) {
		case "SET_DELETE_MODAL_VISIBLE":
			return {
				...state,
				isDeleteModalVisible: action.payload,
			};
		case "SET_WORKSHEET":
			return {
				...state,
				worksheet: action.payload,
			};
		case "SET_OFFSET":
			return {
				...state,
				offset: action.payload,
			};
		case "SET_LOADER1":
			return {
				...state,
				loader1: action.payload,
			};
		case "SET_TEMPLATE_FORM":
			return {
				...state,
				templateFormModal: action.payload,
			};
		case "SET_CRISIS_SPLIT_DATA":
				return {
					...state,
					crisisSplit: action.payload,
				};
		case "SET_SELECT_FILTER_DATA":
				return {
					...state,
					selectFilter: action.payload,
				};
		case "SET_SELECT_SPLIT_DATA":
				return {
					...state,
					selectSplit: action.payload,
				};		
		case "SET_SELECT_BRAND_FILTER_DATA":
				return {
					...state,
					selectBrandFilter: action.payload,
				};
		default:
			return state;
	}
};

export default Worksheets;
